export default __webpack_public_path__ + "locales/sr-Cyrl-RS/Common.json?hash=7d40f4b811dd3b7644663c899adf86dc";